module.exports = __webpack_public_path__ + "assets/Phi.fe794e606441b69ce36bfa00528417ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Phi.png
// module id = 842
// module chunks = 0